import throttle from 'lodash.throttle'

export default class OnPageNavigationController {
    static ITEM_CLASS = 'js-onpage-navigation__nav-item'
    static STICKY_MENU_CLASS = 'js-onpage-navigation--sticky'
    HEADER_HEIGHT = 116
    HEADER_HEIGHT_META_HIDDEN = 80

    constructor() {
        this.initNavigationPinState()
        this.initNavigationItemHighlighting()
    }

    /**
     * Checks the current position of the sticky navigation and adds a class when it is "pinned"/"stuck" to the header
     * Lodash throttle was included to control the execution of the scroll event.
     * Achieving this using the intersection observer seemed to be not possible since the element does not move out of a box but is stuck.
     */
    initNavigationPinState() {
        const navigation = document.querySelector('.' + OnPageNavigationController.STICKY_MENU_CLASS)
        if (!navigation) {
            return
        }
        let pinStateObserver = this.initPinStateObserver(this.HEADER_HEIGHT)
        pinStateObserver.observe(navigation)

        window.addEventListener('header-meta-hidden', () => {
            pinStateObserver.disconnect()
            pinStateObserver = this.initPinStateObserver(this.HEADER_HEIGHT_META_HIDDEN)
            pinStateObserver.observe(navigation)
        })

        window.addEventListener('header-meta-shown', () => {
            pinStateObserver.disconnect()
            pinStateObserver = this.initPinStateObserver(this.HEADER_HEIGHT)
            pinStateObserver.observe(navigation)
        })
    }

    initPinStateObserver(headerHeight) {
        return new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    entry.target.classList.toggle('is-pinned', entry.intersectionRatio < 1)
                })
            },
            { rootMargin: this.getRootMarginTop(headerHeight) + 'px 0px 0px 0px', threshold: [1] }
        )
    }

    getRootMarginTop(headerHeight) {
        return -1 * headerHeight - 1
    }

    initNavigationItemHighlighting() {
        let onPageNavItemAnchors = document.querySelectorAll('.' + OnPageNavigationController.ITEM_CLASS + ' a')

        const onPageNavTargetObserver = new IntersectionObserver(
            function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        const event = new CustomEvent('onPageActive', { detail: { id: entry.target.id } })
                        document.dispatchEvent(event)
                    }
                })
            },
            // -75% ensures, that the nav item is scrolled enough into view before triggering the intersection
            { rootMargin: '0px 0px -75% 0px' }
        )

        onPageNavItemAnchors.forEach((onPageNavItemAnchor) => {
            document.addEventListener(
                'onPageActive',
                (e) => {
                    if (e.detail.id === id) {
                        onPageNavItemAnchor.classList.add('active')
                    } else {
                        onPageNavItemAnchor.classList.remove('active')
                    }
                },
                false
            )

            const id = this.getAnchorLinkFromTag(onPageNavItemAnchor)
            // Check if id is not empty and anchor is on the current page
            if (id !== '' && onPageNavItemAnchor.pathname === location.pathname) {
                try {
                    onPageNavTargetObserver.observe(document.getElementById(id))
                } catch (e) {
                    console.error('Error on initiate Observer for element: ' + id)
                }
            }
        })
    }

    getAnchorLinkFromTag(anchorTag) {
        if (anchorTag.href !== undefined) {
            const splittedHref = anchorTag.href.split('#')
            if (splittedHref.length > 1) {
                return splittedHref[1]
            }
        }
        return ''
    }
}
